import { initializeApp } from 'firebase/app';
import { getDatabase, ref, set, get, child, push, update, remove } from 'firebase/database';

// Your Firebase config
const firebaseConfig = {
  apiKey: "AIzaSyDH-3wwNa7dDigeQ2-gUeIb3NqzJ-J-ec8",
  authDomain: "joberr-565a3.firebaseapp.com",
  databaseURL: "https://joberr-565a3-default-rtdb.firebaseio.com",
  projectId: "joberr-565a3",
  storageBucket: "joberr-565a3.firebasestorage.app",
  messagingSenderId: "47649207652",
  appId: "1:47649207652:web:3cb9708e75c02a327c3671"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const database = getDatabase(app);

// =============================================
// USER - SERVICE FUNCTIONS (Read Only)
// =============================================

// Get all services
export const getServices = async () => {
  try {
    const snapshot = await get(ref(database, 'services'));
    if (snapshot.exists()) {
      return { success: true, data: snapshot.val() };
    }
    return { success: true, data: {} };
  } catch (error) {
    console.error('Error fetching services:', error);
    return { success: false, error: error.message };
  }
};

// Get services as array
export const getServicesArray = async () => {
  try {
    const snapshot = await get(ref(database, 'services'));
    if (snapshot.exists()) {
      const servicesData = snapshot.val();
      const servicesList = Object.keys(servicesData).map(key => ({
        id: key,
        ...servicesData[key]
      }));
      return { success: true, data: servicesList };
    }
    return { success: true, data: [] };
  } catch (error) {
    console.error('Error fetching services:', error);
    return { success: false, error: error.message };
  }
};

// Get a single service by ID
export const getServiceById = async (serviceId) => {
  try {
    const snapshot = await get(ref(database, `services/${serviceId}`));
    if (snapshot.exists()) {
      return { success: true, data: { id: serviceId, ...snapshot.val() } };
    }
    return { success: false, error: 'Service not found' };
  } catch (error) {
    console.error('Error fetching service:', error);
    return { success: false, error: error.message };
  }
};

// Get services by category
export const getServicesByCategory = async (category) => {
  try {
    const snapshot = await get(ref(database, 'services'));
    if (snapshot.exists()) {
      const allServices = snapshot.val();
      const filtered = {};
      for (const [id, service] of Object.entries(allServices)) {
        if (service.category === category) {
          filtered[id] = { id, ...service };
        }
      }
      return { success: true, data: filtered };
    }
    return { success: true, data: {} };
  } catch (error) {
    console.error('Error fetching services by category:', error);
    return { success: false, error: error.message };
  }
};

// =============================================
// USER - HEADER NAVIGATION FUNCTIONS
// =============================================

// Get header navigation from Firebase
export const getHeaderNavigation = async () => {
  try {
    const snapshot = await get(ref(database, 'admin/headerNavigation'));
    if (snapshot.exists()) {
      return { success: true, data: snapshot.val() };
    }
    return { success: true, data: null };
  } catch (error) {
    console.error('Error fetching header navigation:', error);
    return { success: false, error: error.message };
  }
};

// =============================================
// USER - CART FUNCTIONS
// =============================================

export const saveUser = async (userId, userData) => {
  try {
    await set(ref(database, `users/${userId}`), userData);
    return { success: true };
  } catch (error) {
    console.error('Error saving user:', error);
    return { success: false, error: error.message };
  }
};

export const getUser = async (userId) => {
  try {
    const snapshot = await get(ref(database, `users/${userId}`));
    if (snapshot.exists()) {
      return { success: true, data: snapshot.val() };
    }
    return { success: false, data: null };
  } catch (error) {
    console.error('Error getting user:', error);
    return { success: false, error: error.message };
  }
};

export const getUserByEmail = async (email) => {
  try {
    const snapshot = await get(ref(database, 'users'));
    if (snapshot.exists()) {
      const users = snapshot.val();
      for (let userId in users) {
        if (users[userId].email === email) {
          return { success: true, data: { ...users[userId], userId } };
        }
      }
    }
    return { success: false, data: null };
  } catch (error) {
    console.error('Error getting user by email:', error);
    return { success: false, error: error.message };
  }
};

export const saveCart = async (userId, cartItems) => {
  try {
    await set(ref(database, `carts/${userId}`), cartItems);
    return { success: true };
  } catch (error) {
    console.error('Error saving cart:', error);
    return { success: false, error: error.message };
  }
};

export const getCart = async (userId) => {
  try {
    const snapshot = await get(ref(database, `carts/${userId}`));
    if (snapshot.exists()) {
      return { success: true, data: snapshot.val() };
    }
    return { success: true, data: [] };
  } catch (error) {
    console.error('Error getting cart:', error);
    return { success: false, error: error.message };
  }
};

export const addToCart = async (userId, item) => {
  try {
    const cartResult = await getCart(userId);
    let cartItems = cartResult.success ? cartResult.data : [];
    
    const existingIndex = cartItems.findIndex(i => i.id === item.id);
    if (existingIndex === -1) {
      cartItems.push(item);
      await saveCart(userId, cartItems);
    }
    return { success: true, data: cartItems };
  } catch (error) {
    console.error('Error adding to cart:', error);
    return { success: false, error: error.message };
  }
};

export const removeFromCart = async (userId, itemId) => {
  try {
    const cartResult = await getCart(userId);
    if (cartResult.success) {
      const cartItems = cartResult.data.filter(item => item.id !== itemId);
      await saveCart(userId, cartItems);
      return { success: true, data: cartItems };
    }
    return { success: false };
  } catch (error) {
    console.error('Error removing from cart:', error);
    return { success: false, error: error.message };
  }
};

export const clearCart = async (userId) => {
  try {
    await set(ref(database, `carts/${userId}`), []);
    return { success: true };
  } catch (error) {
    console.error('Error clearing cart:', error);
    return { success: false, error: error.message };
  }
};

export const generateUserId = () => {
  return Date.now().toString(36) + Math.random().toString(36).substr(2, 5);
};

export { database };